// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1LpZ6","name":"ConsentHeader_name__2T7yy","birthday":"ConsentHeader_birthday__Z2w14","skeleton":"ConsentHeader_skeleton__1j5h2"};